/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Payments_DescriptionInputs */

const en_admin_payments_description = /** @type {(inputs: Admin_Payments_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`View all payment orders`)
};

const zh_admin_payments_description = /** @type {(inputs: Admin_Payments_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`查看所有支付订单`)
};

/**
* | output |
* | --- |
* | "View all payment orders" |
*
* @param {Admin_Payments_DescriptionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_payments_description = /** @type {((inputs?: Admin_Payments_DescriptionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Payments_DescriptionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_payments_description(inputs)
	return zh_admin_payments_description(inputs)
});
export { admin_payments_description as "admin.payments.description" }